import { useQuery } from "@tanstack/react-query";
import { API } from "config";

const useOptions = (page = 1, term = null) => useQuery({ queryKey: [`options`, page, term],
queryFn: async () => {
  const callback = await API.get(`/options?page=${page}${term ? `&term=${term}` : ''}`)
  return callback?.data
}})

export default useOptions
